/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../../app/base/base.service.ts" />

module Eseebase {
    export class TutorialService {
        constructor(private baseService: BaseService) { }

        public getTutorials() {
            return this.baseService.get('tutorial/list').then(f => { return f.data });
        }

        public createTutorial(tutorial: TutorialViewModel) {
            return this.baseService.post('tutorial/create', tutorial);
        }

        public deleteTutorial(id: string) {
            return this.baseService.delete('tutorial?id=' + id);
        }

    }

    TutorialService.$inject = ['BaseService'];
    angular
        .module('eseebase')
        .service('TutorialService', TutorialService);
}